(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/adress-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/adress-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const ADDRESS1 = svs.ticket_partner.sharedComponents.input.constants.names.ADDRESS1;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input.constants.TEXTS.ADRESS,
  LABEL = _svs$ticket_partner$s.LABEL,
  MAX = _svs$ticket_partner$s.MAX,
  MAX_ERROR = _svs$ticket_partner$s.MAX_ERROR,
  REQUIRED_ERROR = _svs$ticket_partner$s.REQUIRED_ERROR;
const AdressInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state,
    disabled = _ref.disabled,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  return React.createElement(TextInput, {
    disabled: disabled,
    errorMessageMax: MAX_ERROR,
    errorMessageRequired: REQUIRED_ERROR,
    id: ADDRESS1,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: LABEL,
    max: MAX,
    name: name || ADDRESS1,
    onChange: handleChange,
    value: state[ADDRESS1] || ''
  });
};
svs.ticket_partner.sharedComponents.input.AdressInput = AdressInput;

 })(window);